import { DeviceApi } from './types';

const device: DeviceApi = {};

export { device };
